export default __webpack_public_path__ + "static/media/instagram-vuejs.d30360a4.JPG";